import CloneOrg from './clone-org.vue'
export default CloneOrg
